import { render, staticRenderFns } from "./marketAnalysisCom.vue?vue&type=template&id=2bb0f320"
import script from "./marketAnalysisCom.vue?vue&type=script&lang=js"
export * from "./marketAnalysisCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports